import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

function ChildrenItem({
  result,
}: {
  result: {
    gene: string[];
    value: string;
  }[];
}) {
  const { t } = useTranslation();

  return result.length === 0 ? (
    <Text sx={{ padding: '20px 0' }}>{t('normal')} 100%</Text>
  ) : (
    <>
      {result.map((value, i) => (
        <Text
          key={`${value.gene.join('|') || 'normal'}-${value.value}`}
          sx={i === 0 ? { padding: '20px 0' } : { paddingBottom: '20px' }}
        >
          {value.gene.length === 0
            ? `${t('normal')} `
            : value.gene.map((gene) => `${t(gene)} `)}
          {value.value}
        </Text>
      ))}
    </>
  );
}

export default ChildrenItem;
